import moment from 'moment';

import abstractRes from '../abstract.resource';

const mod = angular.module('app.common.resources.keepalive', [abstractRes])

/**
 * @typedef {{expire_timeout: number, next_maintenance: moment, maintenance_note: string, maintenance_end: moment}} KeepaliveData
 */
.factory('KeepaliveResource', function ($http, AbstractResource) {
  class KeepaliveResource extends AbstractResource {
    constructor() {
      super('keepalive', KeepaliveResource.fromBackend, false);
    }

    getMany(...args) { // eslint-disable-line no-unused-vars
      throw new Error('Not applicable for KeepaliveResource.');
    }

    getOne(...args) { // eslint-disable-line no-unused-vars
      throw new Error('Not applicable for KeepaliveResource.');
    }

    /**
     * Get keepalive metadata, such as expiry time and maintenance information from the backend.
     * @returns {Promise.<KeepaliveData>}
     */
    getMetadata() {
      return $http.get(this.url, {headers: this._headers})
      .then(response => KeepaliveResource.fromBackend(response.data));
    }

    /**
     * Refresh the user's session in the backend.
     * @return {Promise}
     */
    sendKeepalive() {
      return $http.post(this.url, {}, {headers: this._headers});
    }

    /**
     * Parse keepalive metadata retrieved from the backend.
     * @param {Object} o
     * @returns {KeepaliveData}
     */
    static fromBackend(o) {
      return {
        expire_timeout: o.expire_timeout,
        next_maintenance: (o.next_maintenance != null) ? moment(o.next_maintenance) : null,
        maintenance_note: o.note,
        maintenance_end: (o.maintenance_end != null) ? moment(o.maintenance_end) : null,
      };
    }
  }

  return new KeepaliveResource();
});

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/common/resources/keepalive.resource.js